import sessionStorageItems from '@/core/enums/sessionStorageItems';
import router from '@/core/router';
import ConsultantService from '@/core/services/consultant';
import { Module } from 'vuex';
const consultantService = new ConsultantService();

const authStore: Module<any, any> = {
   state: {
      permissions: [],
      policyKeys: { journeys: {} },
      roles: [],
      powerBiTokens: null,
      initialized: false,
      consultant: null,
   },

   getters: {
      consultant: (state) => {
         return state.consultant;
      },
      initialized(state) {
         return state.initialized;
      },

      getPolicyKeyByJourneyId: (state) => (journeyId: any) => {
         return state.policyKeys.journeys[journeyId];
      },

      hasJourneyPolicyKey: (state, getters) => (policyKey: any, journeyId: any) => {
         return getters.getPolicyKeyByJourneyId(journeyId)?.[policyKey]?.allowed == 1;
      },
      powerBiTokens(state) {
         return state.powerBiTokens;
      },
   },

   mutations: {
      setPermissions(state, permissions) {
         state.permissions = permissions;
      },

      setPolicyKeys(state, policyKeys) {
         if (policyKeys?.journeys) {
            state.policyKeys.journeys = policyKeys.journeys;
         }
      },

      setRoles(state, roles) {
         state.roles = roles;
      },
      setPowerBiTokens(state, tokens) {
         state.powerBiTokens = tokens || {};
      },

      initialize(state) {
         state.initialized = true;
      },
      setConsultant(state, consultant) {
         state.consultant = consultant;
      },
   },

   actions: {
      async getConsultant(context) {
         var consultantId = sessionStorage.getItem(sessionStorageItems.consultant_id);
         if (consultantId != null) {
            return await consultantService.getConsultant(consultantId).then((response: any) => {
               context.commit('setConsultant', response);
               return response;
            });
         } else {
            // uitloggen
            router.push({ name: 'login-index' });
         }
      },
   },
};

export default authStore;
